import Cable from 'actioncable'
import { getPureOauthAccessToken } from './cookies-helper'

const wsUrl = (process as any).env.REACT_APP_API_BASE_URL.replace(/(http)(s)?\:\/\//, 'ws$2://')

export const cableFactory = () =>
  Cable.createConsumer(`${wsUrl}cable?access_token=${getPureOauthAccessToken()}`)
